import type { CSSProperties } from "react";
import logoUrl from "../logo.svg";

interface ApogeuLogoProps {
  readonly width?: number;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function ApogeuLogo({ width = 120, className, style }: ApogeuLogoProps) {
  return (
    <img
      src={logoUrl}
      alt="Apogeu"
      width={width}
      className={className}
      style={{ display: "block", height: "auto", ...style }}
    />
  );
}
